<template>
    <main class="app-content">
        <router-view></router-view>
    </main>
</template>

<script>

    export default {
        components: {
        },
        data() {
            return {
            }
        },
        methods: {
        },
        mounted() {
        }
    }
</script>

<style lang="css">
</style>
